import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Avatar,
  Stack,
} from "@mui/material";
import { motion } from "framer-motion";

// Sample Data
const team = [
  {
    id: 1,
    name: "Emma Stone",
    role: "Lead Photographer",
    bio: "Emma specializes in capturing the candid moments that make weddings unforgettable.",
    image: "https://img.freepik.com/free-photo/portrait-young-person-holding-camera-device-world-photography-day_23-2151609213.jpg?t=st=1738044774~exp=1738048374~hmac=1dd2a5fef3449a97b86874c150aec7db3bb8f13eb97c5251c4a31aa46c9cc3e1&w=826",
  },
  {
    id: 2,
    name: "Jack Johnson",
    role: "Destination Photographer",
    bio: "Jack has a knack for turning scenic locations into timeless memories.",
    image: "https://img.freepik.com/free-photo/portrait-young-person-holding-camera-device-world-photography-day_23-2151609204.jpg?t=st=1738044654~exp=1738048254~hmac=f11de2c7b3115dc482a9604cc991c753f2ebf2a668ee1439f3c23de94c21e825&w=826",
  },
  {
    id: 3,
    name: "Sophia Lee",
    role: "Creative Director",
    bio: "Sophia ensures every shot tells a unique and captivating story.",
    image: "https://img.freepik.com/free-photo/portrait-young-person-holding-camera-device-world-photography-day_23-2151609209.jpg?t=st=1738044695~exp=1738048295~hmac=77080b70eb0468b236190cbd0dc04c1f3923df7e0c151f0b0af978958c0d4bc8&w=826",
  },
];

const awards = [
  { id: 1, title: "Best Wedding Photographer 2023", organization: "Wedding Awards" },
  { id: 2, title: "Top 10 Destination Photographers", organization: "Global Photography Guild" },
  { id: 3, title: "Excellence in Album Design", organization: "Creative Photography Society" },
];

const AboutUsPage = () => {
  return (
    <Box sx={{ py: 4, px: 2 }}>
      {/* Company Background */}
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontWeight: "bold",
          mb: 4,
          textTransform: "uppercase",
          letterSpacing: 2,
        }}
      >
        About Us
      </Typography>
      <Typography
        variant="body1"
        align="center"
        sx={{ mb: 6, maxWidth: 800, mx: "auto", lineHeight: 1.8 }}
      >
        At Wedding Bliss, we believe that every couple deserves a beautifully
        captured wedding story. Our mission is to create timeless memories that
        you can cherish for a lifetime. With years of experience, a dedicated
        team, and a passion for photography, we are here to make your special
        day unforgettable.
      </Typography>

      {/* Team Section */}
      <Typography
        variant="h5"
        sx={{ fontWeight: "bold", mb: 3, textTransform: "uppercase", letterSpacing: 1 }}
      >
        Meet Our Team
      </Typography>
      <Grid container spacing={3} sx={{ mb: 6 }}>
        {team.map((member) => (
          <Grid item xs={12} sm={6} md={4} key={member.id}>
            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Card sx={{ textAlign: "center", p: 2 }}>
                <Avatar
                  alt={member.name}
                  src={member.image}
                  sx={{ width: 120, height: 120, mx: "auto", mb: 2 }}
                />
                <CardContent>
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {member.name}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    sx={{ mb: 1 }}
                  >
                    {member.role}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {member.bio}
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>

      {/* Awards Section */}
      <Typography
        variant="h5"
        sx={{ fontWeight: "bold", mb: 3, textTransform: "uppercase", letterSpacing: 1 }}
      >
        Awards & Credentials
      </Typography>
      <Stack spacing={2}>
        {awards.map((award) => (
          <motion.div
            key={award.id}
            whileHover={{ scale: 1.02 }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Card sx={{ p: 2, display: "flex", alignItems: "center" }}>
              <CardMedia
                component="img"
                image="https://img.freepik.com/free-vector/realistic-film-adwards-illustration_23-2149338822.jpg?t=st=1738045160~exp=1738048760~hmac=f267c76a152988ba9655811926e385eb2ea4b62b4883d550c6bd1a69f14e0129&w=740"
                alt="Award Badge"
                sx={{ width: 80, height: 80, borderRadius: "50%", mr: 2 }}
              />
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {award.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {award.organization}
                </Typography>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </Stack>
    </Box>
  );
};

export default AboutUsPage;
